<template>
  <div>
    <px-view-header title="Cotações" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:after>
        <px-listagem-cotacao-view-option v-model="selectedViewOption"
                                         @change="onChangeOption"/>
      </template>
    </px-view-header>
    <px-listagem-cotacao v-if="isCotacaoView" />
    <div v-if="!isCotacaoView">
      <px-listagem-cotacao-produtos />
    </div>
  </div>
</template>

<script>
import ListagemCotacao from '@/modules/cotacao/listagem/ListagemCotacao.vue';
import ListagemCotacaoViewOption from '@/modules/cotacao/listagem/ListagemCotacaoViewOption.vue';
import CotacaoViewOptions from '@/enums/cotacao-view-options';
import ListagemCotacaoProdutos
  from '@/modules/cotacao/listagem-produtos/ListagemCotacaoProdutos.vue';
import { mapActions, mapGetters } from 'vuex';
import {
  INIT_STATE_ACTION, RESET_OPTIONS,
  RESET_PAGINATION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-cotacao/actions.type';

export default {
  data() {
    return {
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Cotações' },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['idEntidade']),
    isCotacaoView() {
      return !this.selectedViewOption
        || this.selectedViewOption === CotacaoViewOptions.keys.POR_COTACAO.key;
    },
    selectedViewOption: {
      get() {
        return this.$store.getters['listagemCotacao/viewOption'];
      },
      set(viewOption) {
        this.$store.dispatch('listagemCotacao/viewOption', viewOption);
      },
    },
  },
  methods: {
    ...mapActions('listagemCotacao', {
      resetPagination: RESET_PAGINATION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
      resetPageOptions: RESET_OPTIONS,
    }),
    onChangeOption() {
      this.resetPagination();
      this.resetPageOptions();

      this.setCurrentSessionState({
        idCurrentEntidade: this.idEntidade,
        idCurrentUser: this.user.id,
      });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
  },
  components: {
    pxListagemCotacao: ListagemCotacao,
    pxListagemCotacaoViewOption: ListagemCotacaoViewOption,
    pxListagemCotacaoProdutos: ListagemCotacaoProdutos,
  },
};
</script>
